var swiper = new Swiper(".c-testimonial-swiper", {
    slidesPerView: 1,
    breakpoints: {
        990: {
            slidesPerView: 2
        },
        1200: {
            slidesPerView: 3
        }
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
});